<script>
  import { External, M } from '../../../../external';
  import BecomeMemberActivityDetail from './Body/BecomeMemberActivityDetail.svelte';
  import BookingActivityDetail from './Body/BookingActivityDetail.svelte';
  import FormActivityDetail from './Body/FormActivityDetail.svelte';
  import OrderActivityDetail from './Body/OrderActivityDetail.svelte';
  import SubscriptionCancelledActivityDetail from './Body/SubscriptionCancelledActivityDetail.svelte';
  import MemberGroupActivityDetail from './Body/MemberGroupActivityDetail.svelte';
  import EmailActivityDetail from './Body/EmailActivityDetail.svelte';
  import MarketingListActivityDetail from './Body/MarketingListActivityDetail.svelte';
  import TagActivityDetail from './Body/TagActivityDetail.svelte';
  import PropertyChangedActivityDetail from './Body/PropertyChangedActivityDetail.svelte';
  import MessageReceivedActivityDetail from './Body/MessageReceivedActivityDetail.svelte';
  import MessageSentActivityDetail from './Body/MessageSentActivityDetail.svelte';
  import CommunityPollReactionActivityDetail from './Body/CommunityPollReactionActivityDetail.svelte';
  import VideoActivityDetail from './Body/VideoActivityDetail.svelte';
  import LmsMemberEnrollmentActivityDetail from './Body/LmsMemberEnrollmentActivityDetail.svelte';
  import LmsMemberContentCompletedActivityDetail from './Body/LmsMemberContentCompletedActivityDetail.svelte';
  import { LmsUtils } from '../../../../LMS/utils/LmsUtils';
  import LmsMemberBanningActivityDetail from './Body/LmsMemberBanningActivityDetail.svelte';
  import MemberCommunityGroupMutingActivityDetail from './Body/MemberCommunityGroupMutingActivityDetail.svelte';
  import LmsMemberAccessRequestActivityDetail from './Body/LmsMemberAccessRequestActivityDetail.svelte';
  import LmsMemberAccessRequestResponseActivityDetail from './Body/LmsMemberAccessRequestResponseActivityDetail.svelte';
  import SubscriptionRenewlCancelledActivityDetail from './Body/SubscriptionRenewlCancelledActivityDetail.svelte';

  export let entry, contact;

  let visitCircle = async () => {
    let circleId = entry?.data?.circleId;
    if (circleId) {
      let circles = await LmsUtils.listCircles();
      let circle = circles.find(circle => circle.id === circleId);
      if (circle) {
        External.CPanel.goToUrl(`/me/community/circles/${circle.url}`);
      }
    }
  };

  const activityConfig = {
    ASSIGN_MEMBER_GROUP: {
      iconSvg:
        '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M500-482q29-32 44.5-73t15.5-85q0-44-15.5-85T500-798q60 8 100 53t40 105q0 60-40 105t-100 53Zm220 322v-120q0-36-16-68.5T662-406q51 18 94.5 46.5T800-280v120h-80Zm80-280v-80h-80v-80h80v-80h80v80h80v80h-80v80h-80Zm-480-40q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM0-160v-112q0-34 17.5-62.5T64-378q62-31 126-46.5T320-440q66 0 130 15.5T576-378q29 15 46.5 43.5T640-272v112H0Zm320-400q33 0 56.5-23.5T400-640q0-33-23.5-56.5T320-720q-33 0-56.5 23.5T240-640q0 33 23.5 56.5T320-560ZM80-240h480v-32q0-11-5.5-20T540-306q-54-27-109-40.5T320-360q-56 0-111 13.5T100-306q-9 5-14.5 14T80-272v32Zm240-400Zm0 400Z"/></svg>',
      iconColorClass: 'green-bg',
      title: () => M.ACT_TITLE_ASSIGN_MEMBER_GROUP,
      action: M.ASSIGNED,
      actionClicked: null,
      actionColorClass: 'green-bg',
      component: MemberGroupActivityDetail
    },
    AUTOMATION_STARTED: {
      iconSvg:
        '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M440-82q-76-8-141.5-41.5t-114-87Q136-264 108-333T80-480q0-91 36.5-168T216-780h-96v-80h240v240h-80v-109q-55 44-87.5 108.5T160-480q0 123 80.5 212.5T440-163v81Zm-17-214L254-466l56-56 113 113 227-227 56 57-283 283Zm177 196v-240h80v109q55-45 87.5-109T800-480q0-123-80.5-212.5T520-797v-81q152 15 256 128t104 270q0 91-36.5 168T744-180h96v80H600Z"/></svg>',
      iconColorClass: 'green-bg',
      title: () => {
        return External.format(M.ACT_TITLE_AUTOMATION_STARTED, 'x', entry.data?.automation?.name);
      },
      action: M.STARTED,
      actionClicked: () => {
        const automationId = entry?.data?.automation?.id;
        if (automationId) {
          External.CPanel.goToUrl('/me/crm/marketing/automation?id=' + automationId);
        }
      },
      actionColorClass: 'green-bg',
      component: null
    },
    BECOME_MEMBER: {
      iconSvg:
        '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M500-482q29-32 44.5-73t15.5-85q0-44-15.5-85T500-798q60 8 100 53t40 105q0 60-40 105t-100 53Zm220 322v-120q0-36-16-68.5T662-406q51 18 94.5 46.5T800-280v120h-80Zm80-280v-80h-80v-80h80v-80h80v80h80v80h-80v80h-80Zm-480-40q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM0-160v-112q0-34 17.5-62.5T64-378q62-31 126-46.5T320-440q66 0 130 15.5T576-378q29 15 46.5 43.5T640-272v112H0Zm320-400q33 0 56.5-23.5T400-640q0-33-23.5-56.5T320-720q-33 0-56.5 23.5T240-640q0 33 23.5 56.5T320-560ZM80-240h480v-32q0-11-5.5-20T540-306q-54-27-109-40.5T320-360q-56 0-111 13.5T100-306q-9 5-14.5 14T80-272v32Zm240-400Zm0 400Z"/></svg>',
      iconColorClass: 'green-bg',
      title: () => M.ACT_TITLE_BECOME_MEMBER,
      action: M.CREATED,
      actionClicked: null,
      actionColorClass: 'green-bg',
      component: BecomeMemberActivityDetail
    },
    BOOKING_CANCELLED: {
      iconSvg:
        '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m388-212-56-56 92-92-92-92 56-56 92 92 92-92 56 56-92 92 92 92-56 56-92-92-92 92ZM200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Z"/></svg>',
      iconColorClass: 'red-bg',
      title: () => M.ACT_TITLE_BOOKING_CANCELLED,
      action: M.CANCELLED,
      actionClicked: null,
      actionColorClass: 'red-bg',
      component: BookingActivityDetail
    },
    BOOKING_CREATED: {
      iconSvg:
        '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M438-226 296-368l58-58 84 84 168-168 58 58-226 226ZM200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Z"/></svg>',
      iconColorClass: 'green-bg',
      title: () => M.ACT_TITLE_BOOKING_CREATED,
      action: M.SCHEDULED,
      actionClicked: null,
      actionColorClass: 'green-bg',
      component: BookingActivityDetail
    },
    CHECKOUT_ABANDONED: {
      iconSvg:
        '<svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48" ><path d="M206-120q-20 0-36.5-12T148-164L38-562q-4-14 4.826-26Q51.65-600 67-600h202l185-270q5-6 11-9.5t14-3.5q8 0 14 3.5t11 9.5l184 270h206q15.349 0 24.174 12Q927-576 923-562L812-164q-5 20-21.5 32T754-120H206Zm0-60h548l101-360H106l100 360Zm274.177-120Q505-300 522.5-317.677t17.5-42.5Q540-385 522.323-402.5t-42.5-17.5Q455-420 437.5-402.323t-17.5 42.5Q420-335 437.677-317.5t42.5 17.5ZM342-600h273L479-800 342-600Zm139 240Z" /></svg>',
      iconColorClass: 'red-bg',
      title: () => M.ACT_TITLE_CHECKOUT_ABANDONED,
      action: M.ABANDONED,
      actionClicked: null,
      actionColorClass: 'red-bg',
      component: OrderActivityDetail
    },
    FORM_SUBMITTED: {
      iconSvg:
        '<svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48" ><path d="M180-120q-24.75 0-42.375-17.625T120-180v-600q0-24.75 17.625-42.375T180-840h205q5-35 32-57.5t63-22.5q36 0 63 22.5t32 57.5h205q24.75 0 42.375 17.625T840-780v600q0 24.75-17.625 42.375T780-120H180Zm0-60h600v-600H180v600Zm100-100h273v-60H280v60Zm0-170h400v-60H280v60Zm0-170h400v-60H280v60Zm200-177q14 0 24.5-10.5T515-832q0-14-10.5-24.5T480-867q-14 0-24.5 10.5T445-832q0 14 10.5 24.5T480-797ZM180-180v-600 600Z" /></svg>',
      iconColorClass: 'green-bg',
      title: (entry) => {
        const {
          data: {
            form: { type }
          }
        } = entry;
        if (type === 'FormWidget') {
          return M.ACT_TITLE_FORM_SUBMITTED_FORM;
        } else if (type === 'QuizWidget') {
          return M.ACT_TITLE_FORM_SUBMITTED_QUIZ;
        } else if (type === 'PaymentFormWidget') {
          return M.ACT_TITLE_FORM_SUBMITTED_PAYMENT_FORM;
        } else {
          return M.ACT_TITLE_FORM_SUBMITTED_FORM;
        }
      },
      action: M.SUBMITTED,
      actionClicked: null,
      actionColorClass: 'green-bg',
      component: FormActivityDetail
    },
    ORDER_CREATED: {
      iconSvg:
        '<svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48" ><path d="M206-120q-20 0-36.5-12T148-164L38-562q-4-14 4.826-26Q51.65-600 67-600h202l185-270q5-6 11-9.5t14-3.5q8 0 14 3.5t11 9.5l184 270h206q15.349 0 24.174 12Q927-576 923-562L812-164q-5 20-21.5 32T754-120H206Zm0-60h548l101-360H106l100 360Zm274.177-120Q505-300 522.5-317.677t17.5-42.5Q540-385 522.323-402.5t-42.5-17.5Q455-420 437.5-402.323t-17.5 42.5Q420-335 437.677-317.5t42.5 17.5ZM342-600h273L479-800 342-600Zm139 240Z" /></svg>',
      iconColorClass: 'green-bg',
      title: () => M.ACT_TITLE_ORDER_CREATED,
      action: M.ORDER,
      actionClicked: null,
      actionColorClass: 'green-bg',
      component: OrderActivityDetail
    },
    ORDER_STATUS_CHANGED: {
      iconSvg:
        '<svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48" ><path d="M206-120q-20 0-36.5-12T148-164L38-562q-4-14 4.826-26Q51.65-600 67-600h202l185-270q5-6 11-9.5t14-3.5q8 0 14 3.5t11 9.5l184 270h206q15.349 0 24.174 12Q927-576 923-562L812-164q-5 20-21.5 32T754-120H206Zm0-60h548l101-360H106l100 360Zm274.177-120Q505-300 522.5-317.677t17.5-42.5Q540-385 522.323-402.5t-42.5-17.5Q455-420 437.5-402.323t-17.5 42.5Q420-335 437.677-317.5t42.5 17.5ZM342-600h273L479-800 342-600Zm139 240Z" /></svg>',
      iconColorClass: 'orange-bg',
      title: () => M.ACT_TITLE_ORDER_STATUS_CHANGED,
      action: M.CHANGED,
      actionClicked: null,
      actionColorClass: 'orange-bg',
      component: OrderActivityDetail
    },
    SUBSCRIPTION_CANCELLED: {
      iconSvg:
        '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M160-440v80h640v-80H160Zm0-440h640q33 0 56.5 23.5T880-800v440q0 33-23.5 56.5T800-280H640v200l-160-80-160 80v-200H160q-33 0-56.5-23.5T80-360v-440q0-33 23.5-56.5T160-880Zm0 320h640v-240H160v240Zm0 200v-440 440Z"/></svg>',
      iconColorClass: 'red-bg',
      title: () => M.ACT_TITLE_SUBSCRIPTION_CANCELLED,
      action: M.TERMINATED,
      actionClicked: null,
      actionColorClass: 'red-bg',
      component: SubscriptionCancelledActivityDetail
    },
    SUBSCRIPTION_RENEWAL_CANCELLED: {
      iconSvg:
        '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M160-440v80h640v-80H160Zm0-440h640q33 0 56.5 23.5T880-800v440q0 33-23.5 56.5T800-280H640v200l-160-80-160 80v-200H160q-33 0-56.5-23.5T80-360v-440q0-33 23.5-56.5T160-880Zm0 320h640v-240H160v240Zm0 200v-440 440Z"/></svg>',
      iconColorClass: 'red-bg',
      title: () => M.ACT_TITLE_SUBSCRIPTION_CANCELLED,
      action: M.CANCELLED,
      actionClicked: null,
      actionColorClass: 'red-bg',
      component: SubscriptionRenewlCancelledActivityDetail
    },
    UNASSIGN_MEMBER_GROUP: {
      iconSvg:
        '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M500-482q29-32 44.5-73t15.5-85q0-44-15.5-85T500-798q60 8 100 53t40 105q0 60-40 105t-100 53Zm220 322v-120q0-36-16-68.5T662-406q51 18 94.5 46.5T800-280v120h-80Zm240-360H720v-80h240v80Zm-640 40q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM0-160v-112q0-34 17.5-62.5T64-378q62-31 126-46.5T320-440q66 0 130 15.5T576-378q29 15 46.5 43.5T640-272v112H0Zm320-400q33 0 56.5-23.5T400-640q0-33-23.5-56.5T320-720q-33 0-56.5 23.5T240-640q0 33 23.5 56.5T320-560ZM80-240h480v-32q0-11-5.5-20T540-306q-54-27-109-40.5T320-360q-56 0-111 13.5T100-306q-9 5-14.5 14T80-272v32Zm240-400Zm0 400Z"/></svg>',
      iconColorClass: 'red-bg',
      title: () => M.ACT_TITLE_UNASSIGN_MEMBER_GROUP,
      action: M.UNASSIGNED,
      actionClicked: null,
      actionColorClass: 'red-bg',
      component: MemberGroupActivityDetail
    },
    EMAIL_SENT: {
      iconSvg:
        '<svg style="position: relative; top: 3px; left: 2px;" xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48" ><path d="m734-164-42-42 73-74H584v-60h181l-73-74 42-42 146 146-146 146ZM140-280q-24.75 0-42.375-17.625T80-340v-440q0-24.75 17.625-42.375T140-840h560q24.75 0 42.375 17.625T760-780v232q-7.5-1-15-1.5t-15-.5q-8 0-15 .5t-15 1.5v-185L416-532 140-732v392h351q-1 8-1 13.5v13.75q0 8.25.5 16.5T493-280H140Zm36-500 240 174 246-174H176Zm-36 440v-440 440Z" /></svg>',
      iconColorClass: 'green-bg',
      title: (entry) => {
        switch(entry.data.email.type) {
          case External.CRM_MESSAGE_TYPE.AUTOMATION:
            return M.ACT_TITLE_EMAIL_SENT_AUTOMATION;
          case External.CRM_MESSAGE_TYPE.INDIVIDUAL:
          case External.CRM_MESSAGE_TYPE.INDIVIDUAL_SCHEDULED:
            return M.ACC_TITLE_EMAIL_SENT;
          default:
            return M.ACT_TITLE_EMAIL_SENT_CAMPAIGN;
        }
      },
      action: M.SENT,
      actionClicked: null,
      actionColorClass: 'green-bg',
      component: EmailActivityDetail
    },
    EMAIL_OPENED: {
      iconSvg:
        '<svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48" ><path d="m480-920 371 222q17 9 23 24.5t6 30.5v463q0 24-18 42t-42 18H140q-24 0-42-18t-18-42v-463q0-15 6.5-30.5T109-698l371-222Zm0 466 336-197-336-202-336 202 336 197Zm0 67L140-587v407h680v-407L480-387Zm0 207h340-680 340Z" /></svg>',
      iconColorClass: 'orange-bg',
      title: (entry) => {
        switch(entry.data.email.type) {
          case External.CRM_MESSAGE_TYPE.AUTOMATION:
            return M.ACT_TITLE_EMAIL_OPENED_AUTOMATION;
          case External.CRM_MESSAGE_TYPE.INDIVIDUAL:
          case External.CRM_MESSAGE_TYPE.INDIVIDUAL_SCHEDULED:
            return M.ACC_TITLE_EMAIL_OPENED;
          default:
            return M.ACT_TITLE_EMAIL_OPENED_CAMPAIGN;
        }
      },
      action: M.OPENED,
      actionClicked: null,
      actionColorClass: 'orange-bg',
      component: EmailActivityDetail
    },
    EMAIL_CLICKED: {
      iconSvg:
        '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M16.6372 16.13L13.5 16.13L13.5 14.63L16.6372 14.63C18.0897 14.63 19.2672 13.4525 19.2672 12C19.2672 10.5475 18.0897 9.36999 16.6372 9.36999L13.5 9.36999L13.5 7.86999L16.6372 7.86999C18.9181 7.86999 20.7672 9.71906 20.7672 12C20.7672 14.2809 18.9181 16.13 16.6372 16.13Z" fill="#000000"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M7.36279 7.87L10.5 7.87001L10.5 9.37001L7.36279 9.37C5.91028 9.37 4.73279 10.5475 4.73279 12C4.73279 13.4525 5.91028 14.63 7.36279 14.63L10.5 14.63L10.5 16.13L7.36279 16.13C5.08186 16.13 3.23279 14.2809 3.23279 12C3.23279 9.71907 5.08186 7.87 7.36279 7.87L7.36279 8.59581L7.36279 7.87Z" fill="#000000"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 11.25L16.5 11.25L16.5 12.75L7.5 12.75L7.5 11.25Z" fill="#000000"></path> </g></svg>',
      iconColorClass: 'orange-bg',
      title: (entry) => {
        let title;
        switch (entry.data.email.type) {
          case External.CRM_MESSAGE_TYPE.AUTOMATION:
            title = M.ACT_TITLE_EMAIL_CLICKED_AUTOMATION;
            break;
          case External.CRM_MESSAGE_TYPE.INDIVIDUAL:
          case External.CRM_MESSAGE_TYPE.INDIVIDUAL_SCHEDULED:
            title = M.ACC_TITLE_EMAIL_CLICKED;
            break;
          default:
            title = M.ACT_TITLE_EMAIL_CLICKED_CAMPAIGN;
        }
        return External.format(title, 'x', entry.data.email.subject);
      },
      action: M.CLICKED,
      actionClicked: null,
      actionColorClass: 'orange-bg',
      component: EmailActivityDetail
    },
    MESSAGE_SENT: {
      iconSvg: (entry) => {
        switch (entry.data.message.channel) {
          case External.CRM_MESSAGE_CHANNEL.WHATSAPP:
            return '<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 124 124" viewBox="0 0 124 124" id="whatsapp"><path fill="#000000" fill-rule="evenodd" d="M64,15.8c-25.5,0-46.2,20.7-46.2,46.2c0,9,2.5,17.6,7.4,25.1l-7,15.5 c-0.6,1.4-0.4,3.1,0.6,4.3c0.8,0.9,1.9,1.4,3.1,1.4c0.4,0,0.7,0,1.1-0.1l19.4-5.3c6.7,3.6,14.2,5.5,21.8,5.5 c25.5,0,46.2-20.7,46.2-46.2C110.2,36.5,89.5,15.8,64,15.8z M64,100.2c-6.8,0-13.4-1.8-19.2-5.2c-0.6-0.4-1.3-0.6-2-0.6 c-0.4,0-0.7,0-1.1,0.1L29,98l4.4-9.7c0.6-1.3,0.4-2.9-0.4-4c-4.7-6.5-7.2-14.2-7.2-22.3C25.8,41,43,23.8,64,23.8 c21,0,38.2,17.1,38.2,38.2C102.2,83,85.1,100.2,64,100.2z" clip-rule="evenodd"></path><path fill="#000000" fill-rule="evenodd" d="M81.8,68.9c-1.9-1.2-4.5-2.5-6.7-1.5c-1.7,0.7-2.9,3.5-4,4.9c-0.6,0.7-1.3,0.8-2.2,0.5 c-6.6-2.6-11.6-7-15.2-13c-0.6-0.9-0.5-1.7,0.2-2.6c1.1-1.3,2.5-2.8,2.8-4.5c0.3-1.7-0.5-3.8-1.2-5.3c-0.9-2-1.9-4.8-3.9-5.9 c-1.8-1-4.2-0.5-5.8,0.9c-2.8,2.3-4.2,5.9-4.1,9.4c0,1,0.1,2,0.4,3c0.6,2.3,1.6,4.5,2.9,6.6c0.9,1.6,1.9,3.1,3,4.5 c3.5,4.8,7.9,8.9,12.9,12c2.5,1.5,5.3,2.9,8.1,3.8c3.2,1,6,2.1,9.4,1.5c3.6-0.7,7.1-2.9,8.5-6.3c0.4-1,0.6-2.2,0.4-3.2 C86.6,71.3,83.6,70,81.8,68.9z" clip-rule="evenodd"></path></svg>';
          case External.CRM_MESSAGE_CHANNEL.VOICE:
            return '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M240-520h60v-80h-60v80Zm100 80h60v-240h-60v240Zm110 80h60v-400h-60v400Zm110-80h60v-240h-60v240Zm100-80h60v-80h-60v80ZM80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240L80-80Zm126-240h594v-480H160v525l46-45Zm-46 0v-480 480Z"/></svg>';
          default: /*External.CRM_MESSAGE_CHANNEL.SMS:*/
            return '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M320-520q17 0 28.5-11.5T360-560q0-17-11.5-28.5T320-600q-17 0-28.5 11.5T280-560q0 17 11.5 28.5T320-520Zm160 0q17 0 28.5-11.5T520-560q0-17-11.5-28.5T480-600q-17 0-28.5 11.5T440-560q0 17 11.5 28.5T480-520Zm160 0q17 0 28.5-11.5T680-560q0-17-11.5-28.5T640-600q-17 0-28.5 11.5T600-560q0 17 11.5 28.5T640-520ZM80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240L80-80Zm126-240h594v-480H160v525l46-45Zm-46 0v-480 480Z"/></svg>';
        }
      },
      iconColorClass: 'green-bg',
      title: (entry) => {
        switch (entry.data.message.channel) {
          case External.CRM_MESSAGE_CHANNEL.WHATSAPP:
            switch (entry.data.message.type) {
              case External.CRM_MESSAGE_TYPE.AUTOMATION:
                return M.ACT_TITLE_WHATSAPP_MESSAGE_SENT_AUTOMATION;
              case External.CRM_MESSAGE_TYPE.INDIVIDUAL:
              case External.CRM_MESSAGE_TYPE.INDIVIDUAL_SCHEDULED:
                return M.ACC_TITLE_WHATSAPP_MESSAGE_SENT;
              default:
                return M.ACT_TITLE_WHATSAPP_MESSAGE_SENT_CAMPAIGN;
            }
          case External.CRM_MESSAGE_CHANNEL.SMS:
            switch (entry.data.message.type) {
              case External.CRM_MESSAGE_TYPE.AUTOMATION:
                return M.ACT_TITLE_SMS_MESSAGE_SENT_AUTOMATION;
              case External.CRM_MESSAGE_TYPE.INDIVIDUAL:
              case External.CRM_MESSAGE_TYPE.INDIVIDUAL_SCHEDULED:
                return M.ACC_TITLE_SMS_MESSAGE_SENT;
              default:
                return M.ACT_TITLE_SMS_MESSAGE_SENT_CAMPAIGN;
            }
          case External.CRM_MESSAGE_CHANNEL.VOICE:
            switch (entry.data.message.type) {
              case External.CRM_MESSAGE_TYPE.AUTOMATION:
                return M.ACT_TITLE_VOICE_MESSAGE_SENT_AUTOMATION;
              case External.CRM_MESSAGE_TYPE.INDIVIDUAL:
              case External.CRM_MESSAGE_TYPE.INDIVIDUAL_SCHEDULED:
                return M.ACC_TITLE_VOICE_MESSAGE_SENT;
              default:
                return M.ACT_TITLE_VOICE_MESSAGE_SENT_CAMPAIGN;
            }
        }
      },
      action: M.SENT,
      actionClicked: null,
      actionColorClass: 'green-bg',
      component: MessageSentActivityDetail
    },
    MESSAGE_RECEIVED: {
      iconSvg: (entry) => {
        switch (entry.data.message.channel) {
          case External.CRM_MESSAGE_CHANNEL.WHATSAPP:
            return '<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 124 124" viewBox="0 0 124 124" id="whatsapp"><path fill="#000000" fill-rule="evenodd" d="M64,15.8c-25.5,0-46.2,20.7-46.2,46.2c0,9,2.5,17.6,7.4,25.1l-7,15.5 c-0.6,1.4-0.4,3.1,0.6,4.3c0.8,0.9,1.9,1.4,3.1,1.4c0.4,0,0.7,0,1.1-0.1l19.4-5.3c6.7,3.6,14.2,5.5,21.8,5.5 c25.5,0,46.2-20.7,46.2-46.2C110.2,36.5,89.5,15.8,64,15.8z M64,100.2c-6.8,0-13.4-1.8-19.2-5.2c-0.6-0.4-1.3-0.6-2-0.6 c-0.4,0-0.7,0-1.1,0.1L29,98l4.4-9.7c0.6-1.3,0.4-2.9-0.4-4c-4.7-6.5-7.2-14.2-7.2-22.3C25.8,41,43,23.8,64,23.8 c21,0,38.2,17.1,38.2,38.2C102.2,83,85.1,100.2,64,100.2z" clip-rule="evenodd"></path><path fill="#000000" fill-rule="evenodd" d="M81.8,68.9c-1.9-1.2-4.5-2.5-6.7-1.5c-1.7,0.7-2.9,3.5-4,4.9c-0.6,0.7-1.3,0.8-2.2,0.5 c-6.6-2.6-11.6-7-15.2-13c-0.6-0.9-0.5-1.7,0.2-2.6c1.1-1.3,2.5-2.8,2.8-4.5c0.3-1.7-0.5-3.8-1.2-5.3c-0.9-2-1.9-4.8-3.9-5.9 c-1.8-1-4.2-0.5-5.8,0.9c-2.8,2.3-4.2,5.9-4.1,9.4c0,1,0.1,2,0.4,3c0.6,2.3,1.6,4.5,2.9,6.6c0.9,1.6,1.9,3.1,3,4.5 c3.5,4.8,7.9,8.9,12.9,12c2.5,1.5,5.3,2.9,8.1,3.8c3.2,1,6,2.1,9.4,1.5c3.6-0.7,7.1-2.9,8.5-6.3c0.4-1,0.6-2.2,0.4-3.2 C86.6,71.3,83.6,70,81.8,68.9z" clip-rule="evenodd"></path></svg>';
          default: /*External.CRM_MESSAGE_CHANNEL.SMS:*/
            return '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M320-520q17 0 28.5-11.5T360-560q0-17-11.5-28.5T320-600q-17 0-28.5 11.5T280-560q0 17 11.5 28.5T320-520Zm160 0q17 0 28.5-11.5T520-560q0-17-11.5-28.5T480-600q-17 0-28.5 11.5T440-560q0 17 11.5 28.5T480-520Zm160 0q17 0 28.5-11.5T680-560q0-17-11.5-28.5T640-600q-17 0-28.5 11.5T600-560q0 17 11.5 28.5T640-520ZM80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240L80-80Zm126-240h594v-480H160v525l46-45Zm-46 0v-480 480Z"/></svg>';
        }
      },
      iconColorClass: 'green-bg',
      title: (entry) => {
        switch (entry.data.message.channel) {
          case External.CRM_MESSAGE_CHANNEL.WHATSAPP:
            return M.ACC_TITLE_WHATSAPP_REPLY_RECEIVED;
          default:
            return M.ACC_TITLE_SMS_REPLY_RECEIVED;
        }
      },
      action: M.RECEIVED,
      actionClicked: null,
      beforeLoad: (entry) => {
        if (entry.data.message.channel === External.CRM_MESSAGE_CHANNEL.WHATSAPP) {
          const messageReceivedTime = new Date(entry.timestamp);
          if (!contact.lastMessageReceivedTime || messageReceivedTime > contact.lastMessageReceivedTime) {
            contact.lastMessageReceivedTime = messageReceivedTime;
          }
        }
      },
      actionColorClass: 'green-bg',
      component: MessageReceivedActivityDetail
    },
    ADD_MARKETING_LIST: {
      iconSvg:
        '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M120-320v-80h280v80H120Zm0-160v-80h440v80H120Zm0-160v-80h440v80H120Zm520 480v-160H480v-80h160v-160h80v160h160v80H720v160h-80Z"/></svg>',
      iconColorClass: 'green-bg',
      title: () => M.ACT_TITLE_ADD_MARKETING_LIST,
      action: M.ADDED,
      actionClicked: null,
      actionColorClass: 'green-bg',
      component: MarketingListActivityDetail
    },
    REMOVE_MARKETING_LIST: {
      iconSvg:
        '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m576-80-56-56 104-104-104-104 56-56 104 104 104-104 56 56-104 104 104 104-56 56-104-104L576-80ZM120-320v-80h280v80H120Zm0-160v-80h440v80H120Zm0-160v-80h440v80H120Z"/></svg>',
      iconColorClass: 'red-bg',
      title: () => M.ACT_TITLE_REMOVE_MARKETING_LIST,
      action: M.REMOVED,
      actionClicked: null,
      actionColorClass: 'red-bg',
      component: MarketingListActivityDetail
    },
    ADD_TAG: {
      iconSvg:
        '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M480-200v-80h120l142-200-142-200H200v120h-80v-120q0-33 23.5-56.5T200-760h400q20 0 37.5 9t28.5 25l174 246-174 246q-11 16-28.5 25t-37.5 9H480Zm-9-280ZM200-160v-120H80v-80h120v-120h80v120h120v80H280v120h-80Z"/></svg>',
      iconColorClass: 'green-bg',
      title: () => M.ACT_TITLE_ADD_TAG,
      action: M.ADDED,
      actionClicked: null,
      actionColorClass: 'green-bg',
      component: TagActivityDetail
    },
    REMOVE_TAG: {
      iconSvg:
        '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m738-336-58-58 62-86-142-200H394l-80-80h286q20 0 37 8.5t29 25.5l174 246-102 144Zm54 280L638-210q-9 5-18 7.5t-20 2.5H200q-33 0-56.5-23.5T120-280v-400q0-11 2.5-20t7.5-18l-74-74 56-56 736 736-56 56ZM383-464Zm154-73Zm31 257L200-648v368h368Z"/></svg>',
      iconColorClass: 'red-bg',
      title: () => M.ACT_TITLE_REMOVE_TAG,
      action: M.REMOVED,
      actionClicked: null,
      actionColorClass: 'red-bg',
      component: TagActivityDetail
    },
    PROPERTY_CHANGED: {
      iconSvg:
        '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M200-246q54-53 125.5-83.5T480-360q83 0 154.5 30.5T760-246v-514H200v514Zm280-194q58 0 99-41t41-99q0-58-41-99t-99-41q-58 0-99 41t-41 99q0 58 41 99t99 41ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm80-80h400v-10q-42-35-93-52.5T480-280q-56 0-107 17.5T280-210v10Zm200-320q-25 0-42.5-17.5T420-580q0-25 17.5-42.5T480-640q25 0 42.5 17.5T540-580q0 25-17.5 42.5T480-520Zm0 17Z"/></svg>',
      iconColorClass: 'orange-bg',
      title: () => M.ACT_TITLE_PROPERTY_CHANGED,
      action: M.CHANGED,
      actionClicked: null,
      actionColorClass: 'orange-bg',
      component: PropertyChangedActivityDetail
    },
    SUBSCRIBED: {
      iconSvg:
        '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M720-400v-120H600v-80h120v-120h80v120h120v80H800v120h-80Zm-360-80q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM40-160v-112q0-34 17.5-62.5T104-378q62-31 126-46.5T360-440q66 0 130 15.5T616-378q29 15 46.5 43.5T680-272v112H40Zm80-80h480v-32q0-11-5.5-20T580-306q-54-27-109-40.5T360-360q-56 0-111 13.5T140-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T440-640q0-33-23.5-56.5T360-720q-33 0-56.5 23.5T280-640q0 33 23.5 56.5T360-560Zm0-80Zm0 400Z"/></svg>',
      iconColorClass: 'green-bg',
      title: () => M.ACT_TITLE_SUBSCRIBED,
      action: M.SUBSCRIBED,
      actionClicked: null,
      actionColorClass: 'green-bg',
      component: null
    },
    UNSUBSCRIBED: {
      iconSvg:
        '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M640-520v-80h240v80H640Zm-280 40q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM40-160v-112q0-34 17.5-62.5T104-378q62-31 126-46.5T360-440q66 0 130 15.5T616-378q29 15 46.5 43.5T680-272v112H40Zm80-80h480v-32q0-11-5.5-20T580-306q-54-27-109-40.5T360-360q-56 0-111 13.5T140-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T440-640q0-33-23.5-56.5T360-720q-33 0-56.5 23.5T280-640q0 33 23.5 56.5T360-560Zm0-80Zm0 400Z"/></svg>',
      iconColorClass: 'red-bg',
      title: () => M.ACT_TITLE_UNSUBSCRIBED,
      action: M.UNSUBSCRIBED,
      actionClicked: null,
      actionColorClass: 'red-bg',
      component: null
    },
    AUTOMATION_GOAL_REACHED: {
      iconSvg:
        '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M360-720h80v-80h-80v80Zm160 0v-80h80v80h-80ZM360-400v-80h80v80h-80Zm320-160v-80h80v80h-80Zm0 160v-80h80v80h-80Zm-160 0v-80h80v80h-80Zm160-320v-80h80v80h-80Zm-240 80v-80h80v80h-80ZM200-160v-640h80v80h80v80h-80v80h80v80h-80v320h-80Zm400-320v-80h80v80h-80Zm-160 0v-80h80v80h-80Zm-80-80v-80h80v80h-80Zm160 0v-80h80v80h-80Zm80-80v-80h80v80h-80Z"/></svg>',
      iconColorClass: 'green-bg',
      title: () => {
        return External.format(M.ACT_TITLE_AUTOMATION_GOAL_REACHED, 'x', entry.data?.automation?.name);
      },
      action: M.GOAL_REACHED,
      actionClicked: () => {
        const automationId = entry?.data?.automation?.id;
        if (automationId) {
          External.CPanel.goToUrl('/me/crm/marketing/automation?id=' + automationId);
        }
      },
      actionColorClass: 'green-bg',
      component: null
    },
    COMMUNITY_POLL_REACTION: {
      iconSvg:
        '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M480-560h200v-80H480v80Zm0 240h200v-80H480v80ZM360-520q33 0 56.5-23.5T440-600q0-33-23.5-56.5T360-680q-33 0-56.5 23.5T280-600q0 33 23.5 56.5T360-520Zm0 240q33 0 56.5-23.5T440-360q0-33-23.5-56.5T360-440q-33 0-56.5 23.5T280-360q0 33 23.5 56.5T360-280ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z"/></svg>',
      iconColorClass: 'green-bg',
      title: () => {
        return M.POLL_VOTE;
      },
      action: M.SUBMITTED,
      actionClicked: null,
      actionColorClass: 'green-bg',
      component: CommunityPollReactionActivityDetail
    },
    VIDEO_STARTED: {
      iconSvg:
        '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="m380-300 280-180-280-180v360ZM160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm0-80h640v-480H160v480Zm0 0v-480 480Z"/></svg>',
      iconColorClass: 'green-bg',
      title: () => {
        return M.VIDEO;
      },
      action: M.STARTED,
      actionClicked: null,
      actionColorClass: 'green-bg',
      component: VideoActivityDetail
    },
    VIDEO_COMPLETED: {
      iconSvg:
        '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="m437-398 227-226-57-57-170 170-85-85-56 56 141 142ZM40-120v-80h880v80H40Zm120-120q-33 0-56.5-23.5T80-320v-440q0-33 23.5-56.5T160-840h640q33 0 56.5 23.5T880-760v440q0 33-23.5 56.5T800-240H160Zm0-80h640v-440H160v440Zm0 0v-440 440Z"/></svg>',
      iconColorClass: 'green-bg',
      title: () => {
        return M.VIDEO;
      },
      action: M.VIDEO_COMPLETED,
      actionClicked: null,
      actionColorClass: 'green-bg',
      component: VideoActivityDetail
    },

    LMS_MEMBER_CIRCLE_ENROLLED: {
      iconSvg: '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M160-160q-33 0-56.5-23.5T80-240v-120h80v120h640v-480H160v120H80v-120q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm300-140-56-58 83-82H80v-80h407l-83-82 56-58 180 180-180 180Z"/></svg>',
      iconColorClass: 'green-bg',
      title: () => M.ENROLLED_TO,
      action: M.CIRCLE,
      actionClicked: visitCircle,
      actionColorClass: 'green-bg',
      component: LmsMemberEnrollmentActivityDetail
    },

    LMS_MEMBER_CIRCLE_BANNED: {
      iconSvg: '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M160-160q-33 0-56.5-23.5T80-240v-120h80v120h640v-480H160v120H80v-120q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm300-140-56-58 83-82H80v-80h407l-83-82 56-58 180 180-180 180Z"/></svg>',
      iconColorClass: 'red-bg',
      title: () => M.ACT_TITLE_BANNED_FROM,
      action: M.CIRCLE,
      actionClicked: visitCircle,
      actionColorClass: 'red-bg',
      component: LmsMemberBanningActivityDetail
    },

    LMS_MEMBER_CIRCLE_UNBANNED: {
      iconSvg: '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M160-160q-33 0-56.5-23.5T80-240v-120h80v120h640v-480H160v120H80v-120q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm300-140-56-58 83-82H80v-80h407l-83-82 56-58 180 180-180 180Z"/></svg>',
      iconColorClass: 'green-bg',
      title: () => M.ACT_TITLE_BAN_REMOVED_FROM,
      action: M.CIRCLE,
      actionClicked: visitCircle,
      actionColorClass: 'green-bg',
      component: LmsMemberBanningActivityDetail
    },

    LMS_MEMBER_CIRCLE_UNENROLLED: {
      iconSvg: '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v80h-80v-80H200v560h560v-80h80v80q0 33-23.5 56.5T760-120H200Zm480-160-56-56 103-104H360v-80h367L624-624l56-56 200 200-200 200Z"/></svg>',
      iconColorClass: 'green-bg',
      title: () => M.UNENROLLED_FROM, //M.ACT_TITLE_BECOME_MEMBER,
      action: M.CIRCLE,
      actionClicked: visitCircle,
      actionColorClass: 'green-bg',
      component: LmsMemberEnrollmentActivityDetail
    },

    LMS_MEMBER_GROUP_ENROLLED: {
      iconSvg: '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M160-160q-33 0-56.5-23.5T80-240v-120h80v120h640v-480H160v120H80v-120q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm300-140-56-58 83-82H80v-80h407l-83-82 56-58 180 180-180 180Z"/></svg>',
      iconColorClass: 'green-bg',
      title: () => M.ENROLLED_TO,
      action: M.CIRCLE_GROUP,
      actionClicked: visitCircle,
      actionColorClass: 'green-bg',
      component: LmsMemberEnrollmentActivityDetail
    },

    LMS_MEMBER_GROUP_UNENROLLED: {
      iconSvg: '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v80h-80v-80H200v560h560v-80h80v80q0 33-23.5 56.5T760-120H200Zm480-160-56-56 103-104H360v-80h367L624-624l56-56 200 200-200 200Z"/></svg>',
      iconColorClass: 'green-bg',
      title: () => M.UNENROLLED_FROM,
      action: M.CIRCLE_GROUP,
      actionClicked: visitCircle,
      actionColorClass: 'green-bg',
      component: LmsMemberEnrollmentActivityDetail
    },
    LMS_MEMBER_CONTENT_COMPLETED: {
      iconSvg: '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="m424-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56 216q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>',
      iconColorClass: 'green-bg',
      title: () => M.COMPLETED,
      action: M.CIRCLE_CONTENT,
      actionClicked: visitCircle,
      actionColorClass: 'green-bg',
      component: LmsMemberContentCompletedActivityDetail
    },
    MEMBER_MUTED: {
      iconSvg: '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="m376-400 104-104 104 104 56-56-104-104 104-104-56-56-104 104-104-104-56 56 104 104-104 104 56 56ZM80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240L80-80Zm126-240h594v-480H160v525l46-45Zm-46 0v-480 480Z"/></svg>',
      iconColorClass: 'red-bg',
      title: () => M.ACT_TITLE_MUTED_FROM,
      action: M.CIRCLE,
      actionClicked: null,
      actionColorClass: 'red-bg',
      component: MemberCommunityGroupMutingActivityDetail
    },
    MEMBER_UNMUTED: {
      iconSvg: '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M694-160 553-302l56-56 85 85 170-170 56 57-226 226ZM80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v280h-80v-280H160v525l46-45h274v80H240L80-80Zm80-240v-480 480Z"/></svg>',
      iconColorClass: 'green-bg',
      title: () => M.ACT_TITLE_UNMUTED_FROM,
      action: M.CIRCLE,
      actionClicked: null,
      actionColorClass: 'green-bg',
      component: MemberCommunityGroupMutingActivityDetail
    },
    LMS_MEMBER_CIRCLE_ACCESS_REQUESTED: {
      iconSvg: '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M160-160q-33 0-56.5-23.5T80-240v-120h80v120h640v-480H160v120H80v-120q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm300-140-56-58 83-82H80v-80h407l-83-82 56-58 180 180-180 180Z"/></svg>',
      iconColorClass: 'green-bg',
      title: () => "Requested access to",
      action: M.CIRCLE,
      actionClicked: visitCircle,
      actionColorClass: 'green-bg',
      component: LmsMemberAccessRequestActivityDetail
    },
    LMS_MEMBER_CIRCLE_ACCESS_APPROVED: {
      iconSvg: '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M160-160q-33 0-56.5-23.5T80-240v-120h80v120h640v-480H160v120H80v-120q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm300-140-56-58 83-82H80v-80h407l-83-82 56-58 180 180-180 180Z"/></svg>',
      iconColorClass: 'green-bg',
      title: () => "Request approved to",
      action: M.CIRCLE,
      actionClicked: visitCircle,
      actionColorClass: 'green-bg',
      component: LmsMemberAccessRequestResponseActivityDetail
    },
    LMS_MEMBER_CIRCLE_ACCESS_REJECTED: {
      iconSvg: '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v80h-80v-80H200v560h560v-80h80v80q0 33-23.5 56.5T760-120H200Zm480-160-56-56 103-104H360v-80h367L624-624l56-56 200 200-200 200Z"/></svg>',
      iconColorClass: 'red-bg',
      title: () => "Request rejected from",
      action: M.CIRCLE,
      actionClicked: visitCircle,
      actionColorClass: 'red-bg',
      component: LmsMemberAccessRequestResponseActivityDetail
    }
  };

  const config = activityConfig[entry.activityType];

  const isAdmin = () => {
    return !entry.actionMaker || entry.actionMaker.isAdmin;
  };

  if (config?.beforeLoad) {
    config.beforeLoad(entry);
  }
</script>

{#if config}
  <div class="communication-row col20 f-left">
    <div class:communication-admin={isAdmin()} class:communication-user={!isAdmin()}>
      <div class="communication-wrapper" class:no-body={!config.component}>
        <div class="communication-icon-wrapper flex-none">
          <div class="communication-icon {config.iconColorClass}">
            {#if typeof config.iconSvg === 'function'}
              {@html config.iconSvg(entry)}
            {:else}
              {@html config.iconSvg}
            {/if}
          </div>
        </div>
        <div class="communication-message flex flex-col">
          <div class="communication-header f-left mb-5 flex align-center">
            <h5 class="communication-message-title">{config.title(entry)}</h5>
            <span
              class="communication-action flex-none {config.actionColorClass}"
              style={config.actionClicked ? 'cursor: pointer' : ''}
              on:click={async () => {
                await config.actionClicked && config.actionClicked();
              }}
              on:keyup={async () => {
                await config.actionClicked && config.actionClicked();
              }}>{config.action}</span>
          </div>
          {#if config.component}
            <div class="communication-body f-left">
              <svelte:component this={config.component} activityType={entry.activityType} data={entry.data} {contact} />
            </div>
          {/if}
        </div>
      </div>
      <div class="communication-timestamp">{External.Tools.dateToString(new Date(entry.timestamp), true)}</div>
    </div>
  </div>
{/if}
